'use strict';

wbApp.directive('wbFormResponseCombo', ['$timeout', '$translate', 'formSvc',
    function ($timeout, $translate, formSvc) {
        function formatResult(model) {
            if (!model) {
                return;
            }

            if (!model.isActive) {
                return model.name + ' (' + $translate.instant('TXT_VAL_NOT_ACTIVE') + ')';
            } else {
                return model.name;
            }
        }

        function formatSelection(model) {
            if (!model.isActive) {
                return model.name + ' (' + $translate.instant('TXT_VAL_NOT_ACTIVE') + ')'
            } else {
                return model.name;
            }
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,
            replace: true,
            scope: {
                filterForKindergarten: '='
            },
            link: function (scope, elm, attrs, ctrl) {
                var models = formSvc.getAllForLookup( /* formIDtoInclude */ ctrl.$modelValue, scope.filterForKindergarten);
                $timeout(function () {

                    $(elm).select2({
                        placeholder: (typeof scope.placeholder !== 'undefined') 
                            ? attrs.placeholder
                            : $translate.instant('TXT_PLACEHOLDER_SELECT_FORM_DEFINITION'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: !attrs.required,
                        minimumResultsForSearch: -1,
                        data: models
                    });

                    ctrl.$render();
                });

                // ctrl.$parsers.unshift(function (viewValue) {
                //     if (!viewValue) {
                //         return 0;
                //     } else {
                //         return parseInt(viewValue);
                //     }
                // });
                //
                // ctrl.$formatters.unshift(function (value) {
                //     if (!value) {
                //         return "";
                //     } else {
                //         return value + "";
                //     }
                // });

                ctrl.$render = function () {
                    models.$promise.then(function () {
                        $(elm).select2('val', ctrl.$viewValue);
                    });
                }

                elm.bind("$destroy", function () {
                    elm.select2("destroy");
                });

                attrs.$observe('readonly', function (value) {
                    elm.select2('readonly', !!value);
                });
            }
        }
    }]);    